<section>
  <h2 id="discontinuation-rate-section" class="mb-2 text-sm">Discontinuation Rate</h2>
  <aux-radio-button-group
    [formControl]="discontinuationRateRadioFc"
    display="column"
    name="discontinuationRateGroup"
    class="text-sm"
  >
    <aux-radio-button
      [id]="'overallDiscontinuationRate'"
      [value]="discontinuationValues.PROTOCOL_LEVEL"
      label="Overall Discontinuation Rate"
      subLabel="Use an overall discontinuation rate when you want the same rate applied across all visits"
      [disabled]="discontinuationRateRadioFc.disabled"
      [tooltip]="discontinuationRateRadioFc.disabled ? disableTooltip() : ''"
      auxSkeletonLoader
      [loading]="discontinuationRate.isLoading()"
      [selectedValue]="discontinuationRateRadioFc.value"
    />
    <aux-radio-button
      [id]="'visitsDiscontinuationRate'"
      [value]="discontinuationValues.VISIT_LEVEL"
      label="Visit-Level Discontinuation Rate"
      subLabel="Use a visit-level discontinuation rate when you want rates to vary by visit"
      [disabled]="discontinuationRateRadioFc.disabled"
      [tooltip]="discontinuationRateRadioFc.disabled ? disableTooltip() : ''"
      auxSkeletonLoader
      [loading]="discontinuationRate.isLoading()"
      [selectedValue]="discontinuationRateRadioFc.value"
    />
  </aux-radio-button-group>

  @let showWarning =
    !!initialDiscontinuationRate() &&
    initialDiscontinuationRate() !== discontinuationRateRadioFc.value;

  @if (showWarning) {
    <div class="mt-4 flex items-center rounded-lg border border-gray-900/10 p-4">
      <aux-icon name="AlertTriangle" class="mr-4 flex-shrink-0 text-aux-warn3" [size]="20" />
      <span>
        Switching between overall and visit-level discontinuation rates will remove any rates
        currently defined for this protocol
      </span>
    </div>
  }
</section>
